export enum BrandSteps {
	Introduction = 'Introduction',
	Consent = 'Consent',
	Psd2Login = 'Psd2Login',
	Assets = 'Assets',
	BudgetEditForm = 'BudgetEditForm',
}
